import { injectGlobal } from "styled-components"
import { fonts } from "./theme"

injectGlobal({
  "*, *:before, *:after": {
    boxSizing: "inherit",
    transition: "inherit",
  },

  body: {
    boxSizing: "border-box",
    margin: 0,
    paddingBottom: "32px",
    fontFamily: fonts.sans,
  },

  ".blackbg": {
    backgroundColor: "#22222a",
  },

  "button::-moz-focus-inner": {
    border: 0,
  },

  "::selection": {
    backgroundColor: "UI Dark",
  },

  "::-moz-selection": {
    backgroundColor: "UI Dark",
  },
})



// WEBPACK FOOTER //
// ./src/globalCss.js